import React, { Component } from 'react';
import firebase from 'firebase';
import styled from 'styled-components';
import { format } from 'date-fns';

import OrderItem from './OrderItem';
import OrderCode from './OrderCode';

const RootContainer = styled.div`
	background-color: #ffffff;
	border-radius: 5px;
	display: flex;
	padding: 20px;
	flex-direction: column;
`;

const HeadlineContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const HeadLine = styled.h2`
	max-width: 400px;
	width: 100%;
`;

const HeadLineItem = styled.h3`
	max-width: 400px;
	width: 100%;
	font-weight: 300;
	margin: 0;
`;

const OrderItemContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
`;

class Order extends Component {
	constructor() {
		super();

		this.state = {
			orders: []
		};
	}

	completeOrder = async (orderId) => {
		const db = firebase.firestore();
		const ref = await db.collection('order').doc(orderId).update({ status: true });

		this.fetchData();
	};

	fetchData = async () => {
		const db = firebase.firestore();
		const ref = await db.collection('order').orderBy('date', 'desc').get();
		const state = { ...this.state };
		state.orders = [];
		ref.forEach((doc) => {
			console.log('doc', doc);

			const allInfo = {
				id: doc.id,
				...doc.data()
			};

			state.orders.push(allInfo);
		});

		this.setState({ ...state });
	};

	componentDidMount() {
		this.fetchData();
	}

	render() {
		return (
			<RootContainer>
				<HeadlineContainer>
					<HeadLine>Email</HeadLine>
					<HeadLine>Code</HeadLine>
					<HeadLine>Location</HeadLine>
					<HeadLine>Item</HeadLine>
					<HeadLine>Date</HeadLine>
					<HeadLine>Status</HeadLine>
					<HeadLine>Action</HeadLine>
				</HeadlineContainer>
				{this.state.orders.map((order, index) => {
					return (
						<OrderItemContainer key={index}>
							<OrderItem userId={order.orderByUser} odd={index % 2} item={order} />
							<OrderCode userId={order.orderByUser} odd={index % 2} item={order} />

							<HeadLineItem>{order.location}</HeadLineItem>
							<HeadLineItem>{order.item}</HeadLineItem>
							<HeadLineItem>{format(new Date(order.date), 'yyyy-MM-dd HH:mm')}</HeadLineItem>

							<HeadLineItem>{order.status ? 'Completed' : 'await'}</HeadLineItem>
							<HeadLineItem>
								{order.status ? (
									'Delivered'
								) : (
									<button onClick={() => this.completeOrder(order.id)}>Complete</button>
								)}
							</HeadLineItem>
						</OrderItemContainer>
					);
				})}
			</RootContainer>
		);
	}
}

export default Order;
